<div class="google-btn">
  <img class="google-icon" src="../../assets/imgs/google_logo.svg" alt="google-logo-login" />
  <p class="btn-text">
    {{ text }}
  </p>
</div>
